import * as types from '../mutation-types'
import { api } from '@/modules/api'
import saveFileFromBase64 from '@/utils/saveFileFromBase64'

const state = {
  nominees: [],
  allNomineesWithWinnerStatus: [],
  totalNomineesPages: 0,
  totalNomineesItems: 0
}

const getters = {
  nomineesList: state => state.nominees,
  getAllNomineesWithWinnerStatus: state => state.allNomineesWithWinnerStatus,
  totalNomineesPages: state => state.totalNomineesPages,
  totalNomineesItems: state => state.totalNomineesItems
}

const actions = {
  async getNomineesList ({commit}, payload = {}) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios.get(api.nominees.getNomineesList(payload))
      commit(types.SET_NOMINEES_LIST, response.data)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Nominees wasn\'t uploaded')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async fetchNomineesListWithWiningStatus ({commit}) {
    try {
      const allNomineesWithWinnerStatus = await this.$axios.get(api.nominees.getNomineesListWithStatusWining())
      commit(types.SET_NOMINEES_LIST_WITH_WINNER_STATUS, allNomineesWithWinnerStatus.data)
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Nominees wasn\'t uploaded')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  showError ({commit}) {
    commit(types.CREATE_ERROR_MESSAGE, 'Nominee wasn\'t updated because you selected category which already has a winner')
  },
  async addNominee ({commit}, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.post(api.nominees.addNominee(), payload)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Nominee was added successfully')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Nominee wasn\'t added')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async editNominee ({commit}, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.patch(api.nominees.editNominee(), payload)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Nominee was edited successfully')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Nominee wasn\'t edited')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async removeNominee ({commit}, id) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.delete(api.nominees.removeNominee(id))
      commit(types.CREATE_SUCCESS_MESSAGE, 'Nominee was removed successfully')
    } catch (err) {
      console.log(err.response)
      commit(types.CREATE_ERROR_MESSAGE, 'Nominee wasn\'t removed')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async downloadVotingExcel () {
    try {
      const { data } = await this.$axios({
        method: 'get',
        url: api.nominees.getVotingExcel(),
        responseType: 'arraybuffer'
      })
      saveFileFromBase64(data, 'Voting', 'xlsx')
    } catch (err) {
      throw err
    }
  },
  async downloadVotingExcelIndividual () {
    try {
      const { data } = await this.$axios({
        method: 'get',
        url: api.nominees.getVotingExcelIndividual(),
        responseType: 'arraybuffer'
      })
      saveFileFromBase64(data, 'Voting-Individual', 'xlsx')
    } catch (err) {
      throw err
    }
  },
  async approveNominee ({commit}, id) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.nominees.approveNominee(id))
      commit(types.CREATE_SUCCESS_MESSAGE, 'Nominee was successfully approved')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Failed to approve nominee')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async exportNomineesExcel () {
    try {
      const { data } = await this.$axios({
        method: 'get',
        url: api.nominees.exportNomineesExcel(),
        responseType: 'arraybuffer'
      })
      saveFileFromBase64(data, 'Nominees', 'xlsx')
    } catch (err) {
      throw err
    }
  }
}

const mutations = {
  [types.SET_NOMINEES_LIST] (state, { nominees, totalPages, totalItems }) {
    state.nominees = [...nominees]
    state.totalNomineesPages = totalPages
    state.totalNomineesItems = totalItems
  },
  [types.SET_NOMINEES_LIST_WITH_WINNER_STATUS] (state, { nominees, totalItems }) {
    state.allNomineesWithWinnerStatus = [...nominees]
    state.totalNomineesItems = totalItems
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/nominees.js